var map = {
	"./Copiar.png": 6509,
	"./Eliminar.png": 58741,
	"./bringForwards.png": 32633,
	"./bringToFront.png": 8769,
	"./clear.png": 75451,
	"./connectYourWallet.png": 29087,
	"./connectYourWalletOld.png": 34232,
	"./darkModeIcon.png": 37243,
	"./deselect.png": 96159,
	"./download.png": 9079,
	"./flipHorizontal.png": 58180,
	"./flipVertical.png": 96904,
	"./groupItems.png": 38750,
	"./hamburguer.png": 34962,
	"./lightModeIcon.png": 30989,
	"./lightModeIconOld.png": 59343,
	"./logoExo2.png": 88878,
	"./pintura.png": 84730,
	"./redo.png": 35692,
	"./searchIcon.png": 68643,
	"./select.png": 15939,
	"./sendBackwards.png": 11739,
	"./sendToBack.png": 84716,
	"./share.png": 47836,
	"./theAlienBoyLogo.png": 15039,
	"./undo.png": 2816,
	"./ungroupItems.png": 94769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19188;